var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    clipPath: "url(#discord_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.333 8a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0M9.333 8a.667.667 0 1 0 1.334 0 .667.667 0 0 0-1.334 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 11.333c0 .667 1 2 1.334 2 1 0 1.888-1.111 2.333-2 .445-1.111.333-3.888-1-7.666-.971-.677-2-.894-3-1l-.648 1.282a8 8 0 0 0-2.702 0L6 2.667c-1 .106-2.029.323-3 1-1.333 3.778-1.445 6.555-1 7.666.445.889 1.333 2 2.333 2 .334 0 1.334-1.333 1.334-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.667 11c2.333.667 4.333.667 6.666 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "discord_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDiscord;